<template>
    <div>
        <Layout>
            <Sider class="sidebar" collapsible :collapsed-width="30" :hide-trigger="true" v-model="isCollapsed" ref="lSider1" @on-collapse="changestate" :style="{background:treeDisp?'#fff':'#fff',borderRight:'1px solid #e8eaec'}">
                <Button type="text" @click="toggle" icon="ios-menu" :style="{
                    width:'100%',
                    borderRadius:'0px',
                    boxShadow:'none',
                    color:'white',
                    background:'dodgerblue',
                    display:leftTreeToggleMenuBtn?'block':'none'}" size="small"></Button>
                <div style="position: relative;">
                    <div :style="{textAlign:'center',display:treeDisp?'block':'none'}">
                        <br />
                        <Button type="default" style="display: inline-block;width: 80%" @click="reloadSearch">分类重置</Button>
                    </div>
                    <div class="maskLayer">
                        <FullTree ref="myFullTree" @OnSelectChange="showmap" @OnLocalSelectChange="showmap" @refreshMap="flashMap" :style="{width:'100%',display:treeDisp?'block':'none'}" :key="rid"></FullTree>
                        <!-- 特定情况下的遮罩树 -->
                        <Spin fix v-if="isShowMask" style="width: 199px;height:100%;">
                            <div></div>
                        </Spin>
                    </div>
                </div>
            </Sider>
            <Layout>
                <Content class="content">
                    <div id="dividerDesc1"></div>
                    <div style="padding-left: 5px;">
                        <MyRoadMap ref="myroad" style="margin: 0px 0px;"></MyRoadMap>
                    </div>
                    <SearchEngine class="jd-table-overflow" ref="searchlist" @search-scene="sc"></SearchEngine>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>
<script>
import AsideMenuCache from '../../../components/aside_menu_cache.vue'
import RoadMap from '../../../components/road_map.vue'
// import SearchEngine from './search_main.vue'
import SearchEngine from './user_search_list.vue'
import eventBus from "../event_bus.js"
import store from '../../../store'
export default {
    data() {
        return {
            rid: +new Date(),
            treeDisp: true,
            leftTreeToggleMenuBtn: true,
            isCollapsed: false,
            isShowMask: false,
        }
    },
    components: {
        'SearchEngine': SearchEngine,
        'FullTree': AsideMenuCache,
        'MyRoadMap': RoadMap,
    },
    created() {
        store.state.user.initData.currentVersion = '2'
        //this.$refs.myAsideMenu.init()
    },
    mounted() {
        eventBus.$on('user-refresh-searchengine', () => {
            this.reloadSearch()
        })
    },
    beforeDestroy() {
        eventBus.$off('user-refresh-searchengine')
    },
    methods: {
        //通过emit控制分类树状态

        sc(value) {
            console.log('sc==>')
            if (value === '官方解答') {
                this.isShowMask = true
                //重置左侧树的选中项id值
                if (this.$refs.searchlist.classid) {
                    this.rid = +new Date()
                    this.$refs.searchlist.treeSelect1()
                }

            } else {
                this.isShowMask = false
            }
        },
        toggle() {
            this.$refs.lSider1.toggleCollapse()
        },
        changestate(state) {
            this.treeDisp = !state;
            store.commit('setLeftExpand', this.treeDisp)
        },
        reloadSearch() {
            //更换key以重置组件
            this.rid = +new Date()
            //this.$refs.searchlist.classid=''
            this.$refs.searchlist.treeSelect()
        },
        // onMainSearch() {
        //     this.scrollIntoViewResult()
        // },
        scrollIntoViewResult() {
            var element = document.getElementById("dividerDesc1");
            element.scrollIntoView();
        },
        flashMap(maps) {
            this.$refs.myroad.listen(maps);
        },
        showmap(maps, tabValue, cityValue) {
            console.log(maps, tabValue)
            var id = "";
            var selectNode = null
            var len
            if (maps !== undefined && maps.length > 0) {
                len = maps.length
            }
            if (maps[len - 1].node !== null) {
                selectNode = maps[len - 1].node
                id = selectNode.value
            }
            console.log("showmap id:" + id)
            this.$refs.myroad.listen(maps);
            this.$refs.searchlist.treeSelect(id)
        },
    },
}
</script>
<style lang="less" scoped>
.sidebar {
    background: #fff;
    overflow: auto;
    transition: width .2s ease .2s; //无过度动画
    // Height: 81.8vh;
    height:88vh;
}

.content {
    padding: 0 0 0 10px;
    background: #F7F9FA;
}

.maskLayer /deep/ .ivu-spin-fix {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    width: 100%;
    height: 100%;
    background-color: hsla(0, 0%, 100%, .5);
    cursor: not-allowed;
}
.jd-table-overflow{
    // height: 78.8vh;
    overflow-y: auto;
}
</style>